module.exports = __webpack_public_path__ + "img/1.f2543c63.png";